import { defineMessages } from 'react-intl';

export default defineMessages({
	inputFieldPlaceholder: {
		id: 'google-maps.input-field-placeholder'
	}
})